// Unsubscribe API Configuration

const UNSUBSCRIBE_API_CONFIG = {
  DEV: {
    BASE_URL: "https://0pwqgu87n5.execute-api.eu-north-1.amazonaws.com/prod",
  },
  PROD: {
    BASE_URL: "https://0pwqgu87n5.execute-api.eu-north-1.amazonaws.com/prod",
  },
};

// Current environment
const CURRENT_ENV = "DEV";

// Base URL for current environment
export const UNSUBSCRIBE_BASE_URL =
  UNSUBSCRIBE_API_CONFIG[CURRENT_ENV].BASE_URL;

// API Endpoints
export const UNSUBSCRIBE_ENDPOINTS = {
  SUBMIT_UNSUBSCRIBE: `${UNSUBSCRIBE_BASE_URL}/unsubscribe`,
  GET_UNSUBSCRIBES: `${UNSUBSCRIBE_BASE_URL}/unsubscribes`,
  DELETE_UNSUBSCRIBES: `${UNSUBSCRIBE_BASE_URL}/unsubscribes`,
};

// Default headers
const DEFAULT_HEADERS = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

// API utilities
export const unsubscribeApiUtils = {
  makeRequest: async (url, options = {}) => {
    const config = {
      ...options,
      headers: {
        ...DEFAULT_HEADERS,
        ...options.headers,
      },
    };

    try {
      const response = await fetch(url, config);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message || `HTTP error! status: ${response.status}`,
        );
      }

      return data;
    } catch (error) {
      console.error("API request failed:", error);
      throw error;
    }
  },

  buildQueryString: (params) => {
    return Object.keys(params)
      .filter(
        (key) =>
          params[key] !== undefined &&
          params[key] !== null &&
          params[key] !== "",
      )
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`,
      )
      .join("&");
  },

  exportToCSV: (data, filename) => {
    if (!data || data.length === 0) return;

    const headers = Object.keys(data[0]);
    const csvContent = [
      headers.join(","),
      ...data.map((row) =>
        headers
          .map((header) => {
            const value = row[header];
            const stringValue =
              value === null || value === undefined ? "" : String(value);
            return stringValue.includes(",") ? `"${stringValue}"` : stringValue;
          })
          .join(","),
      ),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
};

// Service functions
export const unsubscribeService = {
  // Submit unsubscribe
  submitUnsubscribe: async (email) => {
    return unsubscribeApiUtils.makeRequest(
      UNSUBSCRIBE_ENDPOINTS.SUBMIT_UNSUBSCRIBE,
      {
        method: "POST",
        body: JSON.stringify({ email }),
      },
    );
  },

  // Get unsubscribes with filtering
  getUnsubscribes: async (options = {}) => {
    const params = {
      page: options.page || 1,
      limit: options.limit || 500,
      ...(options.email && { email: options.email }),
      ...(options.startDate && { startDate: options.startDate }),
      ...(options.endDate && { endDate: options.endDate }),
    };

    const queryString = unsubscribeApiUtils.buildQueryString(params);
    const url = `${UNSUBSCRIBE_ENDPOINTS.GET_UNSUBSCRIBES}?${queryString}`;

    return unsubscribeApiUtils.makeRequest(url, {
      method: "GET",
    });
  },

  // Delete unsubscribes
  deleteUnsubscribes: async (unsubscribeIds) => {
    return unsubscribeApiUtils.makeRequest(
      UNSUBSCRIBE_ENDPOINTS.DELETE_UNSUBSCRIBES,
      {
        method: "DELETE",
        body: JSON.stringify({ unsubscribeIds }),
      },
    );
  },
};
